import React, { forwardRef, useState, useMemo, useCallback, useRef } from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { FieldTypes } from "utils/formUtils";
import GenericMappingForm from "../GenericMappingForm";
import {find} from "lodash";
import { Form } from "antd";
const OstorlabMappingForm = forwardRef(function OstorlabMappingForm({disableProjectFields = false, ...props}, ref) {    
    const [form] = Form.useForm();
    
    const [assetInitialOptions] = useState(() => {
        if (props.record) {
            const { projectId, projectName } = props.record || {};
            if (projectId && projectName) {
                const ids = String(projectId).split(',');
                const names = String(projectName).split(',');
                return ids.map((id, i) => ({ id, name: names[i] }));
            }
        }
        return [];
    });

    const assetOptionsRef = useRef(assetInitialOptions);

    const [initialValues] = useState(() => {
        if (props.record) {
            const { projectId } = props.record || {};
            const selectedAssetIds = projectId ? String(projectId).split(',') : [];
            return [{
                product: props.defaultProduct,
                subProduct: props.defaultSubProduct,
                environment: props.defaultEnvironment,
                projectId: selectedAssetIds
            }];
        }
        return [{
            product: props.defaultProduct,
            subProduct: props.defaultSubProduct,
            environment: props.defaultEnvironment,
            projectId: []
        }];
    });

    const fetchAssets = useCallback((params) => {
        const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(
            props.toolName,
            {
                ...params,
                login_id: props.loginConfigId,
            }
        );
       const newPromise= promise.then((response) => {
            const projects = response?.projects || [];
            assetOptionsRef.current = projects;
            return projects;
        });
        return { promise:newPromise, cancel };
    }, [props.toolName, props.loginConfigId]);

    const getExtraFieldsData = useCallback((config) => {
        const { projectId } = config;
        const ids = Array.isArray(projectId) ? projectId : (projectId ? String(projectId).split(',') : []);
        const getNameById = (id) => {
            const list = assetOptionsRef.current;
            return (find(list,p => String(p.id) === String(id))?.name) || "";
        }
        const names = ids.map(getNameById).filter(Boolean);

        return {
            projectId: ids.join(','),
            projectName: names.join(','),
            ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id })
        };
    }, [assetInitialOptions]);

    const parseExtraFieldsDataFromResponse = useCallback((config) => {
        const { projectId } = config || {};
        return {
            projectId: projectId ? String(projectId).split(',') : [],
            ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id })
        };
    }, []);

    const extraFields = useMemo(() => [{
        name: 'projectId',
        colSpan: '12',
        type: FieldTypes.SELECT,
        label: 'Assets',
        disabled: disableProjectFields,
        rules: [{ required: true, message: `Assets are required` }],
        props: {
            api: fetchAssets,
            mode: "multiple",
            allowClear: true,
            autoFocus: !disableProjectFields,
            showSearch: true,
        }
    }], [fetchAssets, disableProjectFields]); 
     
    return (
        <GenericMappingForm
            form={form}
            ref={ref}
            getExtraFieldsData={getExtraFieldsData}
            parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
            extraFields={extraFields}
            formDefaultValues={initialValues}
            {...props}
        />
    )
});

export default OstorlabMappingForm;